import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`

*{
    box-sizing : border-box;
}

body{
    background : ${({theme})=>theme.background};
    color : ${({theme})=>theme.textColor};
    margin : 0;
    padding : 0;
    transition : all 0.25s linear;
}

.canvas{
    display : grid;
    min-height : 100vh;
    grid-auto-flow : row;
    grid-template-row : auto 1fr auto;
    gap : 0.5rem;
    padding : 2rem;
    width : 100vw;
    align-items : center;
    text-align : center;
}


${'' /* tying box css  */}
.type-box{
    display: block;
    max-width: 1000px;
    height: 140px;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
}

.words{
    font-size: 32px;
    display: flex;
    flex-wrap: wrap;
    color :${({theme})=>theme.typingText};
    ${'' /* color : red; */}

}

.word{
    margin: 5px;
    padding-right: 2px;
}

.hidden-input{
    opacity: 0;
}

.current{
    border-left: 1px solid;
    animation-name: blinking ;
    animation: blinking 2s infinite;
    animation-timing-function: ease;

    @keyframes blinking {
    0%{border-left-color: ${({theme})=>theme.textColor}}
    25%{border-left-color: ${({theme})=>theme.background}}
    50%{border-left-color: ${({theme})=>theme.textColor}}
    75%{border-left-color: ${({theme})=>theme.background}}
    100%{border-left-color: ${({theme})=>theme.textColor}}
}
}

.current-right{
    border-right: 1px solid;
    animation-name: blinkingRight ;
    animation: blinkingRight 2s infinite;
    animation-timing-function: ease;
    
    @keyframes blinkingRight {
    0%{border-right-color: ${({theme})=>theme.textColor}}
    25%{border-right-color: ${({theme})=>theme.background}}
    50%{border-right-color: ${({theme})=>theme.textColor}}
    75%{border-right-color: ${({theme})=>theme.background}}
    100%{border-right-color: ${({theme})=>theme.textColor}}
}

}

.correct{
    color:  ${({theme})=>theme.correct};
}

.incorrect{
    color:  ${({theme})=>theme.incorrect};
    ${'' /* color : red; */}
}

.upper-menu{
    display: flex;
    margin-left: auto;
    margin-right: auto;
    width: 1000px;
    justify-content: space-between;
    padding: 0.5rem;
    font-size: 1.3rem;
}

.modes{
    display: flex;
    gap: 0.4rem;
}

.time-mode:hover{
  color: green;
  cursor: pointer;
}

.footer{
    display: flex;
    margin-left: auto;
    margin-right: auto;
    width: 1000px;
    justify-content: space-between;
}

.stats-box{
    display: flex;
    margin-left: auto;
    margin-right: auto;
    width: 1000px;
    height: auto;
}

.left-stats{
    width: 30%;
    padding: 30px;
}

.right-stats{
    width: 70%;
}

.title{
    font-size: 20px;
    color :${({theme})=>theme.typingBoxText};
}

.subtitle{
    font-size: 30px;
    color :${({theme})=>theme.correct};
}

.header{
    display: flex;
    width: 1000px;
    justify-content: space-between;
    margin-left: auto;
    margin-right: auto;
}

.user-info{
    width: 1000px;
    margin: auto;
    display: flex;
    color: ${({theme})=>theme.background};
    background: ${({theme})=>theme.textColor};
    min-height:2rem;
    border-radius: 20px;
}
.user{
    width: 50%;
    display: flex;
    margin-top: 30px;
    margin-bottom: 30px;
    font-size: 1.5rem;
    border-right: 2px solid;
   
}
.info{
    width: 60%;
    padding: 1rem;
    margin-top: 1rem;
}
.picture{
    width: 40%;
}
.total-tests-taken{
    width: 50%;
    font-size: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
.table,.graph-user-page{
    margin:auto;
    width:1000px;
}
.center-of-screen{
    display:flex;
    min-height:100vh;
    justify-content:center;
    align-item:center;
}
.a,.b{
    color:${({theme})=>theme.textColor};
    margin-left: auto;
    margin-right: auto;
}
    

.restart {
    font-size: 40px;
    margin-top: 5px;
    cursor: pointer;
}

.logo{
    cursor : pointer;
    background-color: ${({theme})=>theme.textColor};
}
   

`


